/**
 * @file Asset Data
 */
import { integerValueFormatter } from 'src/const/statistics/formatters';
import { COLUMN_WIDTH } from 'src/const/column-width';

/**
  * 每项对应的字段
  * {
  *    key: 对应的后端字段
  *    i18nPath: title 文案对应的 key
  *    hint:
  *    hoverKey: 用于表头hover内容，绝大部分列的类型可以由key计算得来，特殊的列需要写死
  *    min-width: 最小宽度
  *    sortable: 是否可排序
  *    align: 对齐方向
  *    header-align: header 对齐方向
  *    formatter(Option): 数据格式化函数
  * }
  */
export const EnumAssetData = [
  {
    i18nPath: 'common_additional_format_show_count',
    key: 'additional_format_show_count',
    hint: 'campaign_hover_stat_data.additional_format_show_count',
    hoverKey: 'campaign_hover_stat_data.additional_format_show_count',
    'min-width': COLUMN_WIDTH.L,
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: integerValueFormatter, // 单元格数据格式化
  },
  {
    i18nPath: 'common_additional_format_outbound_click_count',
    key: 'additional_format_outbound_click_count',
    hint: 'campaign_hover_stat_data.additional_format_outbound_click_count',
    hoverKey: 'campaign_hover_stat_data.additional_format_outbound_click_count',
    'min-width': COLUMN_WIDTH.L,
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: integerValueFormatter, // 单元格数据格式化
  },
  {
    i18nPath: 'common_additional_format_interactive_click_count',
    key: 'additional_format_interactive_click_count',
    hint: 'campaign_hover_stat_data.additional_format_interactive_click_count',
    hoverKey: 'campaign_hover_stat_data.additional_format_interactive_click_count',
    'min-width': COLUMN_WIDTH.L,
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: integerValueFormatter, // 单元格数据格式化
  },
  {
    i18nPath: 'common_additional_format_option_a_click_count',
    key: 'additional_format_option_a_click_count',
    hint: 'campaign_hover_stat_data.additional_format_option_a_click_count',
    hoverKey: 'campaign_hover_stat_data.additional_format_option_a_click_count',
    'min-width': COLUMN_WIDTH.L,
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: integerValueFormatter, // 单元格数据格式化
  },
  {
    i18nPath: 'common_additional_format_option_b_click_count',
    key: 'additional_format_option_b_click_count',
    hint: 'campaign_hover_stat_data.additional_format_option_b_click_count',
    hoverKey: 'campaign_hover_stat_data.additional_format_option_b_click_count',
    'min-width': COLUMN_WIDTH.L,
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: integerValueFormatter, // 单元格数据格式化
  },
];
